import dashboardList from "./dashboard-list";
import dashboardDetails from "./dashboard-details";

import { combineReducers } from "redux";

export default combineReducers({
  dashboardList,
  dashboardDetails,
});
